import { Components } from '../../material';

export const MuiDialog: Components['MuiDialog'] = {
  defaultProps: {
    PaperProps: {
      elevation: 2,
    },
  },
  styleOverrides: {},
};
